/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */
import {
	TOOLTIP_CONTENT_OPTION_DESCRIPTION,
	TOOLTIP_CONTENT_OPTION_ROLE,
	TOOLTIP_CONTENT_OPTION_LOCATION,
	TOOLTIP_CONTENT_OPTION_DURATION,
	TOOLTIP_CONTENT_OPTION_CREW,
	TOOLTIP_CONTENT_OPTION_NEED_BY_DATE,
	TOOLTIP_CONTENT_OPTION_ASSIGN_TO,
	TOOLTIP_CONTENT_OPTION_ATTACHMENTS_NUMBER,
} from '@touchplan/strings';
import { Ticket } from '@touchplan/common';

export interface IHoverOverContentOption {
	id: string;
	label: string;
	propertyName: string;
	ticketData?: (ticket: Readonly<Ticket>) => string;
}

export enum HoverSettingType {
	DisplayDescription = 'displayDescription',
	DisplayRole = 'displayRole',
	DisplayLocation = 'displayLocation',
	DisplayDuration = 'displayDuration',
	DisplayCrew = 'displayCrew',
	DisplayAssignTo = 'displayAssignTo',
	DisplayNeedByDate = 'displayNeedByDate',
	DisplayImageAttachmentsCount = 'displayImageAttachmentsCount',
	DisplayAllCustomFields = 'displayAllCustomFields',
}

export const CONFIGURATION_LIST = [
	{
		id: 'description',
		label: TOOLTIP_CONTENT_OPTION_DESCRIPTION,
		propertyName: HoverSettingType.DisplayDescription,
		ticketData: (ticket) => ticket?.view?.activityName,
	},
	{
		id: 'role',
		label: TOOLTIP_CONTENT_OPTION_ROLE,
		propertyName: HoverSettingType.DisplayRole,
		ticketData: (ticket) => ticket?.view?.role?.view?.roleName,
	},
	{
		id: 'location',
		label: TOOLTIP_CONTENT_OPTION_LOCATION,
		propertyName: HoverSettingType.DisplayLocation,
		ticketData: (ticket) => ticket?.view?.location?.view?.name,
	},
	{
		id: 'duration',
		label: TOOLTIP_CONTENT_OPTION_DURATION,
		propertyName: HoverSettingType.DisplayDuration,
		ticketData: (ticket) => ticket?.view?.durationDays,
	},
	{
		id: 'crew',
		label: TOOLTIP_CONTENT_OPTION_CREW,
		propertyName: HoverSettingType.DisplayCrew,
		ticketData: (ticket) => ticket?.view?.crewSize,
	},
	{
		id: 'assignTo',
		label: TOOLTIP_CONTENT_OPTION_ASSIGN_TO,
		propertyName: HoverSettingType.DisplayAssignTo,
		ticketData: (ticket) => ticket?.view?.assignedProjectMember?.view?.user,
	},
	{
		id: 'needByDate',
		label: TOOLTIP_CONTENT_OPTION_NEED_BY_DATE,
		propertyName: HoverSettingType.DisplayNeedByDate,
		ticketData: (ticket) => ticket?.view?.dateRequested,
	},
	{
		id: 'imageAttachmentsCount',
		label: TOOLTIP_CONTENT_OPTION_ATTACHMENTS_NUMBER,
		propertyName: HoverSettingType.DisplayImageAttachmentsCount,
	},
	{
		id: 'allCustomFields',
		label: 'All Custom Fields',
		propertyName: HoverSettingType.DisplayAllCustomFields,
	},
];
